export const buildTitleLayerSelector = (titleLayer:string)=>{
    return `.layer_${titleLayer}`
}

export const buildTitleLayerClassName = (titleLayer:string)=>{
    return `layer_${titleLayer}`
}

